module.exports = __webpack_public_path__ + "static/media/redicon.472b77fe.jpg";